/**
 * Génère le chemin canonique pour une location (compatibilité ancien site trouvetonrefuge.com).
 * - Refuge: /refuge/refuge-arnord-i
 * - Camping: /camping/auberge-griffon-aventure
 * - Organisation: /organization/antlers-kingfisher-lodge
 * Si pas de slug, fallback: /locations/:id?type=...
 */

import type { LocationDetail } from '../types'

export function getLocationPath(location: {
  id: number
  type: string
  slug?: string | null
}): string {
  const type = (location.type || '').toLowerCase()
  const slug = location.slug?.trim()
  if (slug && (type === 'refuge' || type === 'camping' || type === 'organization' || type === 'organisation')) {
    const segment = type === 'organisation' ? 'organization' : type
    return `/${segment}/${slug}`
  }
  const typeParam = type ? `?type=${encodeURIComponent(type)}` : ''
  return `/locations/${location.id}${typeParam}`
}

/** Ajoute un paramètre de requête à un chemin (gère déjà ?type=… sans produire ?…?from=…). */
export function appendQueryParam(path: string, key: string, value: string): string {
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`
}

export function getLocationPathWithFrom(
  location: Parameters<typeof getLocationPath>[0],
  from?: string | null,
): string {
  const path = getLocationPath(location)
  if (from) {
    return appendQueryParam(path, 'from', from)
  }
  return path
}
